import styled from 'styled-components';

export const StyledSteps = styled.div`
.ant-steps {
    width: 250px;
    margin: 0 auto;
  }
  .ant-steps-item-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white !important;
    border: 1px solid #d9d9d9 !important;
  }
  }
  .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
    .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: white !important;
  }
.ant-steps-item-finish .ant-steps-item-icon {
    background-color: orange !important;
    border-color: orange !important;
  }

  .ant-steps-item-process .ant-steps-item-icon {
    background-color: orange !important;
    border: 2px solid orange !important;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: orange !important;
  }

  .ant-steps.ant-steps-vertical {
    flex-direction: row !important;
    margin-left: 55px;
  }

  .ant-steps-item-tail::after {
  background-color:transparent !important;
  }
    
`;
